export default "__VITE_ASSET__d680bf01__"